<div fxLayout="column"
     fxLayoutAlign="start center"
     *ngIf="bankLinkStatus === BankLinkStatus.Unlinked || !bankLinkStatus">
  <p *ngIf="!displayOnlyButton"
     class="text">For faster access to funds, securely link and verify your bank with <a href="https://plaid.com/" target="_blank"><b>Plaid</b>&trade;</a>.</p>
  <div>
    <button mat-flat-button
            color="primary"
            (click)="linkBank()"
            *ngIf="!isBankLinked && !bankLinkerRunning">
      <mat-icon>link</mat-icon>
      Link your bank
    </button>
    <button mat-flat-button
            color="primary"
            class="linking"
            *ngIf="bankLinkerRunning">
      <span class="loader-1"></span>
      Please wait...
    </button>
    <button mat-flat-button
            color="primary"
            disabled
            *ngIf="isBankLinked">
      <mat-icon>check_circle</mat-icon>
      Bank linked
    </button>
  </div>
